import { getAppHost, getAppEndpointVersion } from 'helpers'
import axios from './axiosInstance'

// List AI Tools
export const list = async (app, appSettings, pageNo = 1, searchText = '', queryParams = '') => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/tools`
    
    const params = new URLSearchParams()
    if (pageNo) params.append('page', pageNo)
    if (searchText) params.append('search', searchText)
    
    // Add query parameters from the component (e.g., ?type=tool or ?type=action)
    let url = baseURL
    if (queryParams && queryParams.startsWith('?')) {
      // If we have custom query params, use them first
      url = `${baseURL}${queryParams}`
      // Then add any additional params if they exist
      if (params.toString()) {
        url = `${url}&${params.toString()}`
      }
    } else {
      // Use the standard params approach
      url = params.toString() ? `${baseURL}?${params.toString()}` : baseURL
    }
    
    const response = await axios.get(url, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}

// Get single AI Tool
export const get = async (app, appSettings, toolName) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/tools/${encodeURIComponent(toolName)}`
    
    const response = await axios.get(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}

// Get AI Tool Edit Form
export const getEditForm = async (app, appSettings, toolName) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/forms/tool-edit/${encodeURIComponent(toolName)}`
    
    const response = await axios.get(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}

// Add AI Tool
export const add = async (app, appSettings, toolData) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/tools`
    
    const response = await axios.post(baseURL, toolData, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}

// Update AI Tool
export const update = async (app, appSettings, toolName, toolData) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/tools/${encodeURIComponent(toolName)}`
    
    const response = await axios.put(baseURL, toolData, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}

// Delete AI Tool
export const remove = async (app, appSettings, toolName) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/tools/${encodeURIComponent(toolName)}`
    
    const response = await axios.delete(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}
